import constants from '@Common/Core/Constant';
import { Command } from '@Common/ApplicationCore/Command';

const commandIds = constants.commands;
const commandsDef = {
    projectMode: {
        id: commandIds.projectMode,
        name: strings.commands.projectMode,
        toggle: true,
        icon: 'ProjectMode'
    },
    newDocument: {
        id: commandIds.newDocument,
        name: strings.commands.newDocument,
        icon: 'NewDocument',
        globalShortcut: true
    },
    open: {
        id: commandIds.open,
        name: strings.commands.open,
        icon: 'Open',
        shortcut: {
            ctrlKey: true,
            keyCode: 79 // o
        },
        globalShortcut: true
    },
    save: {
        id: commandIds.save,
        name: strings.commands.save,
        icon: 'Save',
        shortcut: {
            ctrlKey: true,
            keyCode: 83 // s
        },
        globalShortcut: true
    },
    saveAll: {
        id: commandIds.saveAll,
        name: strings.commands.saveAll,
        icon: 'SaveAll',
        shortcut: {
            ctrlKey: true,
            shiftKey: true,
            keyCode: 83 // s
        },
        allDocuments: true,
        globalShortcut: true
    },
    recentItems: {
        id: commandIds.recentItems,
        name: strings.commands.recentItems,
        icon: 'documents',
        dynamic: true
    },
    deleteDocument: {
        id: commandIds.deleteDocument,
        name: strings.commands.deleteDocument,
        icon: 'Delete'
    },
    rename: {
        id: commandIds.rename,
        name: strings.commands.rename,
        icon: 'Rename'
    },
    saveAs: {
        id: commandIds.saveAs,
        name: strings.commands.saveAs,
        icon: 'saveas'
    },
    close: {
        id: commandIds.close,
        name: strings.commands.close,
        icon: 'Close'
    },
    closeAll: {
        id: commandIds.closeAll,
        name: strings.commands.closeAll,
        allDocuments: true
    },
    changePassword: {
        id: commandIds.changePassword,
        name: strings.contextMenuItems.changePassword,
        icon: 'ChangePassword'
    },
    logout: {
        id: commandIds.logout,
        name: strings.commands.logout,
        icon: 'Logout'
    },
    about: {
        id: commandIds.about,
        name: strings.commands.about,
        icon: 'AboutInfo'
    },
    help: {
        id: commandIds.help,
        name: strings.commands.help,
        icon: 'Help'
    },

    moveLeft: {
        id: commandIds.moveLeft,
        shortcut: {
            keyCode: 37 // left arrow
        }
    },
    moveTop: {
        id: commandIds.moveTop,
        shortcut: {
            keyCode: 38 // up arrow
        }
    },
    moveRight: {
        id: commandIds.moveRight,
        shortcut: {
            keyCode: 39 // right arrow
        }
    },
    moveBottom: {
        id: commandIds.moveBottom,
        shortcut: {
            keyCode: 40 // down arrow
        }
    },

    resizeWLeft: {
        id: commandIds.resizeWLeft,
        shortcut: {
            keyCode: 37, // left arrow
            ctrlKey: true
        }
    },
    resizeWRight: {
        id: commandIds.resizeWRight,
        shortcut: {
            keyCode: 39, // right arrow
            ctrlKey: true
        }
    },
    resizeELeft: {
        id: commandIds.resizeELeft,
        shortcut: {
            keyCode: 37, // left arrow
            shiftKey: true
        }
    },
    resizeERight: {
        id: commandIds.resizeERight,
        shortcut: {
            keyCode: 39, // right arrow
            shiftKey: true
        }
    },

    resizeNTop: {
        id: commandIds.resizeNTop,
        shortcut: {
            keyCode: 38, // up arrow
            ctrlKey: true
        }
    },
    resizeNBottom: {
        id: commandIds.resizeNBottom,
        shortcut: {
            keyCode: 40, // down arrow
            ctrlKey: true
        }
    },
    resizeSTop: {
        id: commandIds.resizeSTop,
        shortcut: {
            keyCode: 38, // up arrow
            shiftKey: true
        }
    },
    resizeSBottom: {
        id: commandIds.resizeSBottom,
        shortcut: {
            keyCode: 40, // down arrow
            shiftKey: true
        }
    },

    copy: {
        id: commandIds.copy,
        name: strings.commands.copy,
        shortcut: {
            keyCode: 67, // c
            ctrlKey: true
        },
        icon: 'copy'
    },
    paste: {
        id: commandIds.paste,
        name: strings.commands.paste,
        shortcut: {
            keyCode: 86, // v
            ctrlKey: true
        },
        icon: 'paste'
    },
    dataWizard: {
        id: commandIds.dataWizard,
        name: strings.contextMenuItems.dataWizard
    },
    timeWizard: {
        id: commandIds.timeWizard,
        name: strings.contextMenuItems.timeWizard
    },
    displayWizard: {
        id: commandIds.displayWizard,
        name: strings.contextMenuItems.displayWizard
    },
    actionWizard: {
        id: commandIds.actionWizard,
        name: strings.contextMenuItems.actionWizard
    },

    showAnchors: {
        id: commandIds.showAnchors,
        icon: 'anchors',
        name: strings.commands.showAllAnchors,
        toggle: true,
        value: false
    },

    deleteComponents: {
        id: commandIds.deleteComponents,
        name: strings.commands.deleteComponents,
        icon: 'delete',
        shortcut: {
            keyCode: 46 // del
        }
    },

    deleteAnchors: {
        id: commandIds.deleteAllAnchors,
        name: strings.commands.deleteAllAnchors,
        icon: 'deleteallanchors'
    },

    autoAnchors: {
        id: commandIds.autoAnchors,
        name: strings.commands.autoAnchors,
        icon: 'autolink'
    },

    snapToGrid: {
        id: commandIds.snapToGrid,
        name: strings.commands.snapToGrid,
        toggle: true,
        value: true,
        icon: 'snaptogrid'
    },

    blackCanvas: {
        id: commandIds.blackCanvas,
        name: strings.commands.blackCanvas,
        toggle: true,
        icon: 'blackcanvas'
    },

    sendToBack: {
        id: commandIds.sendToBack,
        name: strings.commands.sendToBack,
        icon: 'sendtoback'
    },

    bringToFront: {
        id: commandIds.bringToFront,
        name: strings.commands.bringToFront,
        icon: 'bringtofront'
    },

    reorderHorizontal: {
        id: commandIds.reorderHorizontal,
        name: strings.commands.reorderHorizontal,
        icon: 'reorderhorizontal'
    },

    reorderVertical: {
        id: commandIds.reorderVertical,
        name: strings.commands.reorderVertical,
        icon: 'reordervertical'
    },

    studioSettings: {
        id: commandIds.studioSettings,
        name: strings.commands.studioSettings,
        icon: 'dashboardSettings'
    },

    generateLocalizationTables: {
        id: commandIds.generateLocalizationTables,
        name: strings.commands.generateLocalizationTables,
        icon: 'generateLanguages'
    },

    filterGroups: {
        id: commandIds.filterGroups,
        name: strings.commands.filterGroups,
        icon: 'filter'
    },

    exportProjectDocuments: {
        id: commandIds.exportProjectDocuments,
        name: strings.commands.exportProjectDocuments,
        icon: 'export'
    },

    exportProjectDocumentsToSourceFolder: {
        id: commandIds.exportProjectDocumentsToSourceFolder,
        name: strings.commands.exportProjectDocumentsToSourceFolder,
        icon: 'ExportToFolder'
    },

    importProjectDocuments: {
        id: commandIds.importProjectDocuments,
        name: strings.commands.importProjectDocuments,
        icon: 'import'
    },

    createSubProcess: {
        id: commandIds.createSubProcess,
        name: strings.commands.createSubProcess,
        icon: 'createSubProcess'
    },

    deleteSubProcess: {
        id: commandIds.deleteSubProcess,
        name: strings.commands.deleteSubProcess,
        icon: 'deleteSubProcess'
    },

    updateAllProjects: {
        id: commandIds.updateAllProjects,
        name: strings.commands.updateAllProjects,
        icon: 'updateAllProjects'
    },

    importSolutions: {
        id: commandIds.importSolutions,
        name: strings.commands.importSolutions,
        icon: 'importSolutions'
    },

    editComponent: {
        id: commandIds.editComponent,
        name: strings.commands.edit
    },

    specifiedColors: {
        id: commandIds.specifiedColors,
        icon: 'titleColors',
        name: strings.commands.specifiedColors
    },

    preview: {
        id: commandIds.preview,
        name: strings.commands.preview,
        icon: 'preview'
    },

    openInViewer: {
        id: commandIds.openInViewer,
        name: strings.commands.openInViewer,
        icon: 'previewHTML'
    },

    undo: {
        id: commandIds.undo,
        name: strings.commands.undo,
        icon: 'undo',
        shortcut: {
            keyCode: 90, // z
            ctrlKey: true
        },
        globalShortcut: true
    },

    redo: {
        id: commandIds.redo,
        name: strings.commands.redo,
        icon: 'redo',
        shortcut: {
            keyCode: 89, // y
            ctrlKey: true
        },
        globalShortcut: true
    },

    refreshEditor: {
        id: commandIds.refreshEditor,
        name: strings.commands.refreshEditor,
        icon: 'refresh'
    },

    publish: {
        id: commandIds.publish,
        name: strings.commands.publish,
        icon: 'publish',
        shortcut: {
            keyCode: constants.keyCodes.KEY_B, // y
            ctrlKey: true,
            altKey: true
        }
    },

    publishAndRebuild: {
        id: commandIds.publishAndRebuild,
        name: strings.commands.publishAndRebuild,
        icon: 'publish-rebuild'
    },

    zoom: {
        id: commandIds.zoom,
        name: strings.commands.zoom,
        icon: 'zoom',
        dynamic: true
    },
    schedule: {
        id: commandIds.schedule,
        name: strings.dataLoadManager.scheduleButton,
        icon: 'schedule'
    },
    unschedule: {
        id: commandIds.unschedule,
        name: strings.dataLoadManager.unscheduleButton,
        icon: 'unschedule'
    },
    refreshDataLoads: {
        id: commandIds.refreshDataLoads,
        name: strings.dataLoadManager.refresh,
        icon: 'refresh'
    },
    cancelDataLoads: {
        id: commandIds.cancelDataLoads,
        name: strings.dataLoadManager.cancelDataLoads,
        icon: 'delete'
    },
    resumeDataLoads: {
        id: commandIds.resumeDataLoads,
        name: strings.dataLoadManager.resumeDataLoads,
        icon: 'Scheduler-Log-Start'
    },
    addRecordDate: {
        id: commandIds.addRecordDate,
        name: strings.dataLoadManager.addRecordDate,
        icon: 'add_24'
    },
    removeSelectedDate: {
        id: commandIds.removeSelectedDate,
        name: strings.dataLoadManager.removeSelectedDate,
        icon: 'delete'
    },
    refreshRecordDates: {
        id: commandIds.refreshRecordDates,
        name: strings.dataLoadManager.refresh,
        icon: 'refresh'
    },
    refreshSchedulerLog: {
        id: commandIds.refreshSchedulerLog,
        name: strings.dataLoadManager.refresh,
        icon: 'refresh'
    },
    startSchedulerLog: {
        id: commandIds.startSchedulerLog,
        name: strings.dataLoadManager.start,
        icon: 'Scheduler-Log-Start'
    },
    stopSchedulerLog: {
        id: commandIds.stopSchedulerLog,
        name: strings.dataLoadManager.stop,
        icon: 'Scheduler-Log-stop'
    },
    turnOnEditMode: {
        id: commandIds.turnOnEditMode,
        name: strings.commands.turnOnEditMode,
        icon: 'Scheduler-Log-Start'
    },
    turnOffEditMode: {
        id: commandIds.turnOffEditMode,
        name: strings.commands.turnOffEditMode,
        icon: 'Scheduler-Log-stop'
    },
    getLogs: {
        id: commandIds.getLogs,
        name: strings.commands.getLogs,
        icon: 'Download-Logs'
    },
    resaveAll: {
        id: commandIds.resaveAll,
        name: strings.commands.resaveAll,
        icon: 'ResaveAll'
    },
    fixReferences: {
        id: commandIds.fixReferences,
        name: strings.commands.fixReferences,
        icon: 'Node-Update-Connections'
    },
    editTheme: {
        id: commandIds.editTheme,
        name: strings.commands.editTheme,
        icon: 'Edit-Theme'
    },
    changeViewLayout: {
        id: commandIds.changeViewLayout,
        name: strings.commands.changeViewLayout,
        icon: 'Change-View-Layout',
        dynamic: true
    },
    toggleTestSession: {
        id: commandIds.toggleTestSession,
        name: strings.commands.toggleTestSession,
        icon: 'Test-case-record-start-2',
        toggleIcon: 'Test-case-record-stop',
        toggle: true
    },
    tenantsUpdate: {
        id: commandIds.tenantsUpdate,
        name: strings.commands.tenantsUpdate,
        icon: 'tenantsUpdate'
    },
    tenantsUpgrade: {
        id: commandIds.tenantsUpgrade,
        name: strings.commands.tenantsUpgrade,
        icon: 'tenantsUpgrade'
    },
    generateRModel: {
        id: commandIds.generateRModel,
        name: strings.commands.generateRModel,
        icon: 'generate-r-model'
    },
    openDimensionManager: {
        id: commandIds.openDimensionManager,
        name: strings.commands.openDimensionManager,
        icon: 'dimension-manager'
    }
};

export const commands = commandsDef as Record<keyof typeof commandsDef, Command>;
